import { Link } from "react-router-dom";

export const Logo = ({ testid = "site-logo" }) => (
  <Link to="/" className="flex items-center gap-2.5 rounded-full" data-testid={testid} aria-label="MUCCI Academy home">
    <span className="relative h-10 w-10 shrink-0">
      <img src="/images/mucci-icon.png" alt="" width="40" height="40" className="h-10 w-10 rounded-2xl" data-testid={`${testid}-icon`} />
      <span className="absolute -right-1.5 -top-1.5 h-3.5 w-3.5 rounded-full bg-lemon" aria-hidden="true" />
    </span>
    <span className="font-heading text-xl font-semibold tracking-tight text-ink">
      MUCCI <span className="font-normal">Academy</span>
    </span>
  </Link>
);
